import React, {useEffect, useRef, useState} from "react";
import moment from "moment";
import { Link } from "gatsby";

import leftArrow from "../../images/arrow--left.svg";
import rightArrow from "../../images/arrow--right.svg";

export default function UpcomingEvents(props) {
	let events = props.content.elements;
	if (props.dynamicEvents) {
		events = getDynamicEventList()
	}
	let currentSlideIndex = 0;
	let slideSize = events.length;
	let elementSize = 0;
	const [visibleElements, setVisibleElements] = useState(2);
	const [width, setWidth] = useState(0);

	const element = useRef();

	useEffect(() => {
		const isBrowser = typeof window !== "undefined"

		if(isBrowser){
			setWidth(window.innerWidth);
			window.addEventListener("resize", () => setWidth(window.innerWidth));
		}

		if(width && width < 576){
			setVisibleElements(1);
		}
	},[width]);

	const [marginLeft, setMarginLeft] = useState(0);

	function slideLeft() {
		if (currentSlideIndex >= 1) {
			currentSlideIndex--;
		}
		slide();
	}

	function slideRight() {
		if (currentSlideIndex < slideSize && visibleElements < slideSize) {
			currentSlideIndex++;
		}
		slide();
	}

	function slide() {
		elementSize = element.current.offsetWidth;
		setMarginLeft(-currentSlideIndex * elementSize);
	}

	function getDynamicEventList() {
		try {
			return props.dataProvider.raw.allContentfulEventPost.nodes.filter(eventPost => {
				return moment().isBefore(moment(eventPost.date))
			})
		} catch (e) {
			return []
		}
	}

	if (!slideSize) {
		return <></>
	}

	return (
		<section key={props.key} className={`${props.content.color === "yellow" ? "podcasts" : "events"} slider-container`}>
			<div className={"container"}>
				<div className='decorate-container'>
					<div className='decorate'>
						<span className='decorate__item' />
						<span className='decorate__item' />
					</div>
				</div>
				<div className='row events--header section--header'>
					<div className='col-md-6'>
						<h2>{props.content.title}</h2>
					</div>
				</div>

				<div className='row event-carousel'>
					<div className='col-12 order-2 order-lg-1 button-group'>
						<div className={`slider--arrows ${slideSize <= visibleElements && 'invisible'}`}>
							<button className='arrow arrow-left' onClick={() => slideLeft()}>
								<img src={leftArrow} alt='' />
							</button>
							<button className='arrow arrow-right' onClick={() => slideRight()}>
								<img src={rightArrow} alt='' />
							</button>
						</div>
					</div>
					<div className='col-lg-12 order-1 order-lg-2'>
						<div className='slider events--slider'>
							<div className='slider--content'>
								<div className='slider'>
									<ul className='slider-row' style={{ marginLeft: marginLeft }}>
										{events.map((event, index) => {
											return (
												<li key={index} ref={element} className={`slider-col ${index === 0 && "active"}`}>
													<a href={event.isExternalLink ? event.slug :`/events/${event.slug}`} target={event.isExternalLink ? '_blank' : '_self'}>
														<div className={`${props.content.color === "yellow" ? "podcast" : "event"}-item`}>
															<div className={`${props.content.color === "yellow" ? "podcast" : "event"}-item--top`}>
																<div className='date'>
																	<p>{moment(event.date).format("DD")}</p>
																	<span>{moment(event.date).format("MMMM")}</span>
																</div>
																<div className='text'>
																	<p>{event.excerpt}</p>
																</div>
															</div>
															<div className={`${props.content.color === "yellow" ? "podcast" : "event"}-item--bottom`}>
																<div className='title'>
																	<p>{event.title}</p>
																</div>
															</div>
														</div>
													</a>
												</li>
											);
										})}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
